import { Builder } from '@builder.io/sdk';
import { BuilderInputOptions } from '@/types/builder';
import Embed from './Embed';

const EmbedConfig = {
  name: 'EmbedTC',
  friendlyName: 'Embed TC',
  override: true,
  inputs: [
    {
      name: 'title',
      type: 'string',
    },
    {
      name: 'url',
      friendlyName: 'URL',
      type: 'string',
    },
    {
      name: 'embedContent',
      helperText: "Will take precedence over 'URL'",
      type: 'longText',
    },
    {
      name: 'width',
      type: 'string',
    },
    {
      name: 'height',
      type: 'string',
    },
    {
      name: 'sandbox',
      helperText:
        "Sandbox limits embeded content's access to the browser. For security and privacy reasons it is recommended to leave this enabled.",
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'allowScripts',
      helperText: 'Sandbox option to allow scripts.',
      type: 'boolean',
      showIf: (options: BuilderInputOptions) => !!options.get('sandbox'),
    },
    {
      name: 'allowSameOrigin',
      helperText: 'Sandbox option to allow same-origin access.',
      type: 'boolean',
      showIf: (options: BuilderInputOptions) => !!options.get('sandbox'),
    },
    {
      name: 'allowForms',
      helperText: 'Sandbox option to allow form submission.',
      type: 'boolean',
      showIf: (options: BuilderInputOptions) => !!options.get('sandbox'),
    },
    {
      name: 'noReferrer',
      helperText: 'Do not send referrer URL to content host.',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'disableCookieValidation',
      helperText:
        "Disabling this will show embeded content regardless of user's cookie preferences. \nIt is recommended not to disable this in production unless you are sure the content does not use tracking cookies.",
      type: 'boolean',
      defaultValue: false,
    },
  ],
};

Builder.registerComponent(Embed, EmbedConfig);
